import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useState } from "react"
import colors from "theme/colors"
import { Container, NewText, ReportsWrapper } from "ui"
import TabPanel from "ui/TabPanel"
import TabTitle from "ui/TabTitle"
import { extractProperty } from "utils"

const StyledPageDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 0px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 0px;
  }
`

const StyledTabsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
`
const StyledButton = styled(Button)``

const StyledButtonDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
`

type Props = {
  data: any
  additional: string
  children: React.ReactNode
}

function MediaInvestorsTab({ data, additional, children }: Props) {
  const title = extractProperty(data, "title")
  const tabs = extractProperty(data, "tabs")
  const [value, setValue] = useState(0)
  const [count, setCount] = useState(6)

  const onHandleButton = () => {
    setCount((prev) => prev + 6)
  }

  return (
    <Container>
      <StyledPageDiv>
        {children}
        <NewText
          component={"h1"}
          desktopFontSize={40}
          desktopLineHeight={"44px"}
          desktopFontWeight={400}
          mobileFontSize={32}
          mobileLineHeight={"36px"}
          color={colors.black}
          marginTop={"32px"}
        >
          {title}
        </NewText>
        <TabTitle tabs={tabs} setValue={setValue} value={value} eventName="מהתקשורת" />
        {tabs.map((block: any, index: number) => (
          <TabPanel value={value} index={index} key={index.toString()}>
            <StyledTabsWrapper>
              {block.properties
                .find((prop: any) => prop.propertyName === "immediateReportsBoks")
                ?.propertyValue?.blocks?.slice(0, count)
                .map((data: any, k: number) => {
                  return <ReportsWrapper key={k.toString()} data={data} mainTitle={title} />
                })}
            </StyledTabsWrapper>
            {count <
              block.properties.find((prop: any) => prop.propertyName === "immediateReportsBoks")
                ?.propertyValue?.blocks.length && (
              <StyledButtonDiv>
                {" "}
                <StyledButton onClick={() => onHandleButton()}>{additional}</StyledButton>
              </StyledButtonDiv>
            )}
          </TabPanel>
        ))}
      </StyledPageDiv>
    </Container>
  )
}

export default MediaInvestorsTab
